<template>
  <Button
    variant="primary"
    :disabled="loading || isDisabled"
    class="flex items-center gap-[8px]"
    @click="$emit('packing')"
  >
    <b-spinner
      v-if="loading || orderStatus === ''"
      small
    />
    <span>{{ btnLabel }}</span>
  </Button>
</template>

<script>
import { Button } from '@/@core/components/ui'

export default {
  name: 'ButtonPackingProduk',
  components: {
    Button,
  },
  props: {
    status: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      orderStatus: this.status,
      loading: false,
      isDisabled: false,
    }
  },
  computed: {
    btnLabel() {
      if (this.orderStatus === '') {
        return 'loading...'
      }
      if (this.orderStatus === 'Belum Dipacking') {
        return 'Packing Produk'
      }
      if (this.orderStatus === 'Dipacking') {
        return 'Order Terkirim'
      }
      if (this.orderStatus === 'Dikirim') {
        return 'Order Terkirim'
      }
      return 'Order Terkirim'
    },
  },
  watch: {
    orderStatus(newVal) {
      if (newVal !== 'Belum Dipacking') {
        this.isDisabled = true
      }
    },
  },
  methods: {
    /**
     * Set the order status
     * @public exposed to the parent component via $refs
     * @param {string} value - The value to set the order status
     * @returns {void}
     */
    setOrderStatus(value) {
      this.orderStatus = value
    },
    /**
     * Set the loading state
     * @public exposed to the parent component via $refs
     * @param {boolean} value - The value to set the loading state
     * @returns {void}
     */
    setLoading(value) {
      this.loading = value
    },
    /**
     * Set the disabled state
     * @public exposed to the parent component via $refs
     * @param {boolean} value - The value to set the disabled state
     * @returns {void}
     */
    setDisabled(value) {
      this.isDisabled = value
    },
  },
}
</script>
